module.exports = __webpack_public_path__ + "img/TopExpert.b83be6ed.jpg";